<template>
  <div class="agent-gifts">
    <br />
    <h1 class="text-xs-center">Agent Gifts</h1>
    <div v-if="agentNameLabel" class="text-xs-center mb-2">{{ agentNameLabel }}</div>
    <div class="text-xs-center mb-3">
      <v-btn
        flat
        small
        :to="{ name: 'agents-agent', params: { agentId: agentId } }"
      >
        <v-icon left small>fas fa-arrow-left</v-icon>
        Agent profile
      </v-btn>
    </div>
    <div v-if="currentAgentError" class="text-xs-center pa-3">{{ currentAgentError }}</div>
    <div v-else>
      <v-data-table
        :headers="headers"
        :items="gifts"
        :loading="apiInProgress"
        hide-actions
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.amountLabel }}</td>
            <td>{{ props.item.fromLabel }}</td>
            <td>{{ props.item.toLabel }}</td>
            <td><small>{{ props.item.dateCreatedLabel }}</small></td>
            <td><small>{{ props.item.dateAcceptedLabel }}</small></td>
            <td><small>{{ props.item.dateCancelledLabel }}</small></td>
          </tr>
        </template>
        <template v-slot:no-data>
          <div class="text-xs-center pa-3">No gifts found for this agent</div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
